import {useTranslation} from '@/translations/i18n'
import {AnswerField, Content, YesNoAnswerField} from '../atoms/Atoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {forwardRef} from 'react'
import {Category} from '@/features/experience-shell/types'
import {RemapExperienceForViewOnly} from '@/features/experience-view-only/types'

export const LegalStep = forwardRef<HTMLDivElement, {experience: RemapExperienceForViewOnly}>(({experience}, ref) => {
    const {t} = useTranslation()
    const category = experience.category.category?.keyName

    return (
        <Flexbox direction="column" fullWidth ref={ref}>
            <Content title={t('experience_shell:step_legal')}>
                {category == Category.enum.food_drink ? (
                    <>
                        <YesNoAnswerField
                            labelTitle={t('experience_view_only:legal_alcohol_check')}
                            yesNoValue={experience.expertise.answers.host_serve_alcohol?.answer}
                        />

                        {!!experience.expertise.answers.host_serve_alcohol?.answer && (
                            <YesNoAnswerField
                                labelTitle={t('experience_shell:legal_licensed_alcohol')}
                                yesNoValue={experience.expertise.answers.is_licensed_establishment?.answer}
                            />
                        )}

                        <YesNoAnswerField
                            labelTitle={t('experience_shell:legal_food_check')}
                            yesNoValue={experience.expertise.answers.host_serve_food?.answer}
                        />

                        {!!experience.expertise.answers.host_serve_food?.answer && (
                            <YesNoAnswerField
                                labelTitle={t('experience_shell:legal_licensed_food')}
                                yesNoValue={experience.expertise.answers.prepared_in_restaurant?.answer}
                            />
                        )}
                    </>
                ) : category == Category.enum.entertainment ? (
                    <>
                        <YesNoAnswerField
                            labelTitle={t('experience_view_only:legal_alcohol_check')}
                            yesNoValue={experience.expertise.answers.host_serve_alcohol?.answer}
                        />

                        {!!experience.expertise.answers.host_serve_alcohol?.answer && (
                            <YesNoAnswerField
                                labelTitle={t('experience_shell:legal_licensed_alcohol')}
                                yesNoValue={experience.expertise.answers.is_licensed_establishment?.answer}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <YesNoAnswerField
                            labelTitle={t('experience_shell:legal_national_park_check')}
                            yesNoValue={experience.expertise.answers.involves_national_park?.answer}
                        />

                        <YesNoAnswerField
                            labelTitle={t('experience_shell:legal_point_of_interest_check')}
                            yesNoValue={experience.expertise.answers.involves_point_of_interest?.answer}
                        />

                        {!!experience.expertise.answers.involves_point_of_interest?.answer && (
                            <YesNoAnswerField
                                labelTitle={t('experience_shell:discuss_significance')}
                                yesNoValue={experience.expertise.answers.host_discusses_poi_significance?.answer}
                            />
                        )}
                    </>
                )}

                <YesNoAnswerField
                    labelTitle={t('experience_shell:legal_transporting_guests_check')}
                    yesNoValue={experience.expertise.answers.host_transports_guests?.answer}
                />

                {!!experience.expertise.answers.host_transports_guests?.answer && (
                    <AnswerField
                        labelTitle={t('experience_view_only:legal_transporting_guests_mode')}
                        hasValue={!!experience.expertise.answers.host_transporting_guests_method?.answer.length}
                        value={experience.expertise.answers.host_transporting_guests_method?.answer
                            .filter(Boolean)
                            .map(method => t(`experience_shell:legal_transporting_guests_mode_${method}`))
                            .join(', ')
                            .toLocaleLowerCase()}
                    />
                )}
            </Content>
        </Flexbox>
    )
})

LegalStep.displayName = 'LegalStep'
